import styled from 'styled-components';
import Text from '../../../../../typography';

export const InputPrefixSC = styled.div`
  height: 36px;
  padding: 0 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PrefixTextSC = styled(Text)``;
